/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RoleData } from '../models/role-data';

@Injectable({
  providedIn: 'root',
})
export class RoleService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation roleGet
   */
  static readonly RoleGetPath = '/api/Role/Get';

  /**
   * Szerepkörök lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleGet$Plain$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    AllowedRolesRestriction?: boolean;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RoleData>>> {

    const rb = new RequestBuilder(this.rootUrl, RoleService.RoleGetPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('AllowedRolesRestriction', params.AllowedRolesRestriction, {});
      rb.query('OrderColumns', params.OrderColumns, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('MaxPageSize', params.MaxPageSize, {});
      rb.query('SkipTotalItemCount', params.SkipTotalItemCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleData>>;
      })
    );
  }

  /**
   * Szerepkörök lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roleGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleGet$Plain(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    AllowedRolesRestriction?: boolean;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<Array<RoleData>> {

    return this.roleGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RoleData>>) => r.body as Array<RoleData>)
    );
  }

  /**
   * Szerepkörök lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleGet$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    AllowedRolesRestriction?: boolean;
    EditingUserId?: number | null;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RoleData>>> {

    const rb = new RequestBuilder(this.rootUrl, RoleService.RoleGetPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('AllowedRolesRestriction', params.AllowedRolesRestriction, {});
      rb.query('EditingUserId', params.EditingUserId, {});
      rb.query('OrderColumns', params.OrderColumns, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('MaxPageSize', params.MaxPageSize, {});
      rb.query('SkipTotalItemCount', params.SkipTotalItemCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleData>>;
      })
    );
  }

  /**
   * Szerepkörök lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleGet(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    AllowedRolesRestriction?: boolean;
    EditingUserId?: number | null;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<Array<RoleData>> {

    return this.roleGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RoleData>>) => r.body as Array<RoleData>)
    );
  }

  /**
   * Path part for operation roleReflexRoles
   */
  static readonly RoleReflexRolesPath = '/api/Role/ReflexRoles';

  /**
   * Reflex szerepkörök lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleReflexRoles$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleReflexRoles$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RoleData>>> {

    const rb = new RequestBuilder(this.rootUrl, RoleService.RoleReflexRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleData>>;
      })
    );
  }

  /**
   * Reflex szerepkörök lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roleReflexRoles$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleReflexRoles$Plain(params?: {
  },
  context?: HttpContext

): Observable<Array<RoleData>> {

    return this.roleReflexRoles$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RoleData>>) => r.body as Array<RoleData>)
    );
  }

  /**
   * Reflex szerepkörök lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleReflexRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleReflexRoles$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RoleData>>> {

    const rb = new RequestBuilder(this.rootUrl, RoleService.RoleReflexRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleData>>;
      })
    );
  }

  /**
   * Reflex szerepkörök lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roleReflexRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleReflexRoles(params?: {
  },
  context?: HttpContext

): Observable<Array<RoleData>> {

    return this.roleReflexRoles$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RoleData>>) => r.body as Array<RoleData>)
    );
  }

}
